import { CustomCookieService } from "./providers/mycookie.service";
import { Injectable } from "@angular/core";
import { Constant } from './Constant'

@Injectable()
export class AuthService {

  loggedIn = false;

  constructor(private cookie: CustomCookieService) {

  }

  isAuthenticated() {
    const promise = new Promise(
      (resolve, reject) => {
        setTimeout(() => {
          resolve((this.cookie.getCookieData(Constant.KEY_LOGINSTATUS) == 'true'));
        }, 0);
      }
    );
    return promise;
  }

  login() {
    this.loggedIn = true;
    this.cookie.setCookieData(Constant.KEY_LOGINSTATUS, 'true');
  }

  logout() {
    this.loggedIn = false;
    this.cookie.setCookieData(Constant.KEY_LOGINSTATUS, 'false');
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts